import { Badge } from "@newsela/angelou";

import { IMetadata, isDecodableContent } from "@/view/utils/decodableContent";
import { rootCss } from "./DecodableBadge.style";

interface DecodableBadgeProps {
  contentMetadata: IMetadata[];
  isStudentMode: boolean;
}

export const DecodableBadge = ({
  contentMetadata,
  isStudentMode,
}: DecodableBadgeProps): JSX.Element => {
  const hasDecodableBadge = isDecodableContent(contentMetadata);

  if (isStudentMode || !hasDecodableBadge) return <></>;

  return (
    <Badge
      text="Decodable"
      flavor={Badge.flavor.solid}
      color={Badge.color.black}
      size={Badge.size.md}
      hideIcon
      __cssFor={{ root: rootCss }}
    />
  );
};
export default DecodableBadge;
